export class YoutubePlaceholder {

    constructor() {
        this.$modal = $('.js-youtube-cookie-modal');
        this.$placeholder = $('.js-youtube-cookie-popup');
        this.$body = $('body');
        this.$body.on('click', '.ui-overlay', () => this.close());

        // show popup
        this.$placeholder.on('click', () => this.open());
    }

    open() {
        this.$body.addClass('body--no-scroll');
        this.$modal.show();
        this.$body.append('<div class="ui-overlay"></div>');
    }

    close() {
        this.$modal.fadeOut();
        this.$body.removeClass('body--no-scroll');
        $('.ui-overlay').remove();
    }

}
